import DorkListComposer from "./Components/DorkListComposer";
import {Container} from "@mui/material";
import Author from "./Components/Author";
import "./style/App.css"
function App() {
  return (

    <Container maxWidth="xl">
      <div className="App">
        <DorkListComposer/>
        <hr></hr>
        <Author/>
      </div>
    </Container>
  );
}

export default App;
